import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.918 3.386A9.954 9.954 0 0112 2c5.523 0 10 4.477 10 10v.1M3.38 6.925A9.954 9.954 0 002 12c0 4.66 3.187 8.575 7.5 9.685m11.208-4.764a10.02 10.02 0 01-6.208 4.764m-.41-15.311A6 6 0 006.377 14.1m11.247-4.192a6 6 0 01-7.701 7.723M12 10v4"
    })
  ]))
}